import { Link } from "react-router-dom"
import React from "react"
import "./TabButton.css"
export default function ({ text, pathName, data, type, target, disabled, className }) {
  // console.log(pathName);

  return (
    <div
      className={
        (type === "active" ? " tabButton tabButtonActive" : "inactiveTabButton") +
        (disabled ? " tabButtonDisabled" : "") +
        (className ? " " + className : "")
      }
    >
      <Link
        to={{
          pathname: pathName,
          data: data,
        }}
        target={target}
      >
        {text}
      </Link>
    </div>
  )
}
